import { render, staticRenderFns } from "./btnAnima.vue?vue&type=template&id=54c61b16&scoped=true&"
import script from "./btnAnima.vue?vue&type=script&lang=js&"
export * from "./btnAnima.vue?vue&type=script&lang=js&"
import style0 from "./btnAnima.vue?vue&type=style&index=0&id=54c61b16&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c61b16",
  null
  
)

export default component.exports